import axios from 'axios'
import type { ResponseWithMeta, UploadFileResponse } from '~/types'

export const fileUploadInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: false,
  headers: {},
})

export interface SignedFileUrlResponse {
  data: {
    url: string
  }
}

export const useFileUpload = () => {
  const uploadPublic = (file: File, category: string) => {
    const body = new FormData()
    body.append('file', file)
    body.append('category', category)
    return fileUploadInstance.post<ResponseWithMeta<UploadFileResponse>>('/belajar-id/file/upload/public', body)
  }

  const uploadPrivate = (file: File, category: string) => {
    const body = new FormData()
    body.append('file', file)
    body.append('category', category)
    return fileUploadInstance.post<ResponseWithMeta<UploadFileResponse>>('/belajar-id/file/upload/private', body)
  }

  // GET /download/{file_id}/private — self-serve refresh for a signed URL that expired
  // (~15 min validity) while a page stayed open, e.g. the upgrade-license attachment link
  // (PRD KLRP-420 §3/§4.2). Path mirrors the upload endpoints' /belajar-id/file/... prefix
  // by convention — PRD only documents the relative route, confirm this exact path with
  // BE/file-service docs before wiring it up. Not called from any page yet.
  const downloadPrivate = (fileId: string) => {
    return fileUploadInstance.get<SignedFileUrlResponse>(`/belajar-id/file/download/${fileId}/private`)
  }

  return { uploadPublic, uploadPrivate, downloadPrivate }
}
